"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectUserForm = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SubmitButton = require("../form/SubmitButton");

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

var _Textarea = require("../form/Textarea");

var _Textarea2 = _interopRequireDefault(_Textarea);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _reduxConnect = require("redux-connect");

var _projects = require("../../redux/modules/projects");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectUserForm = exports.ProjectUserForm = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProjectUserForm, _Component);

  function ProjectUserForm(props) {
    (0, _classCallCheck3.default)(this, ProjectUserForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProjectUserForm.__proto__ || (0, _getPrototypeOf2.default)(ProjectUserForm)).call(this, props));

    _this.state = { value: "" };

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.addEmail = _this.addEmail.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ProjectUserForm, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.setState({ value: event.target.value });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var id = this.props.params.id;

      this.addEmail(parseInt(id), this.state.value);
    }
  }, {
    key: "addEmail",
    value: function addEmail(projectId, email) {
      var addProjectUserEmail = this.props.addProjectUserEmail;

      addProjectUserEmail(projectId, email);
    }
  }, {
    key: "render",
    value: function render() {
      var userEmail = this.props.userEmail;


      return _react2.default.createElement(
        "form",
        { onSubmit: this.handleSubmit },
        _react2.default.createElement(
          "label",
          null,
          this.showAddedEmail(),
          "Name:",
          _react2.default.createElement("textarea", {
            type: "text",
            value: this.state.value,
            onChange: this.handleChange
          })
        ),
        _react2.default.createElement("input", {
          type: "submit",
          className: "button button-set-width button-submit",
          value: "Lis\xE4\xE4"
        })
      );
    }
  }, {
    key: "showAddedEmail",
    value: function showAddedEmail() {
      var userEmail = this.props.userEmail;

      if (userEmail) {
        return _react2.default.createElement(
          "div",
          { className: "voucher-order-cart" },
          _react2.default.createElement(
            "p",
            null,
            " ",
            userEmail.project_id,
            " added"
          )
        );
      }
    }
  }]);
  return ProjectUserForm;
}(_react.Component), _class.propTypes = {
  addProjectUserEmail: _react.PropTypes.func.isRequired,
  userEmail: _react.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    userEmail: state.projects.userEmail
  };
}, {
  addProjectUserEmail: _projects.addProjectUserEmail
})(ProjectUserForm);


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/projects/ProjectUserForm.js
 ** module id = 1176
 ** module chunks = 0
 **/